import { BrowserModule } from '@angular/platform-browser';

import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './services/loading.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from '@angular/flex-layout';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { MatTableExporterModule } from 'mat-table-exporter';

import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from '@ngx-gallery/lightbox';

declare module "@angular/core" {
    interface ModuleWithProviders<T = any> {
        ngModule: Type<T>;
        providers?: Provider[];
    }
}
@NgModule({
	declarations: [AppComponent],
	imports: [
	    HttpClientModule,
		BrowserModule,
		routing,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		AmplifyAngularModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		ChartsModule,
		MatTableExporterModule,
		GalleryModule,
		LightboxModule
	],
	providers: [AmplifyService,
		{
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptor,
		multi: true,
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: LoadingInterceptor,
		multi: true,
	},
],
	bootstrap: [AppComponent]
})
export class AppModule {
}
